/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Print_Admin_Queued_JobsInputs */

const vi_print_admin_queued_jobs = /** @type {(inputs: Print_Admin_Queued_JobsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đang chờ in: ${i?.count}`)
};

/**

* @param {Print_Admin_Queued_JobsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const print_admin_queued_jobs = /** @type {((inputs: Print_Admin_Queued_JobsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_Admin_Queued_JobsInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_print_admin_queued_jobs(inputs)
});